import SwiftMessageOrderApi from '@/services/Api/SwiftMessageOrderApi'
import ApiRequest from '@/services/ApiRequests/ApiRequest'

const swiftMessageOrderTotalCountApiRequest = new ApiRequest(SwiftMessageOrderApi.fetchTotalCount)

const state = () => ({
  swiftOrderMessageTypes: [],
  loaded: false,
  totalCount: 0
})

const getters = {
  swiftOrderMessageTypeOptions (state) {
    return state.swiftOrderMessageTypes.map(type => ({
      name: type,
      value: String(type)
    }))
  },
  loaded (state) {
    return state.loaded
  },
  swiftMessageOrderTotalCount: (state) => {
    return state.totalCount
  }
}

const actions = {
  loadSwiftOrderMessageTypes ({ commit }) {
    return SwiftMessageOrderApi.fetchMessageTypes()
      .then(({ payload }) => {
        commit('setMessageTypes', payload)
        commit('setLoaded')
      })
  },
  loadSwiftMessageOrderTotalCount ({ commit }) {
    return swiftMessageOrderTotalCountApiRequest.execute({})
      .then(payload => commit('setCounter', payload.count))
      .catch(() => {})
  },
  cancelLoadSwiftMessageOrderTotalCount () {
    swiftMessageOrderTotalCountApiRequest.cancel()
  }
}

const mutations = {
  setMessageTypes (state, messageTypes) {
    state.swiftOrderMessageTypes = messageTypes
  },
  setLoaded (state) {
    state.loaded = true
  },
  setCounter (state, totalCount) {
    state.totalCount = totalCount
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
